import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';

import {AppComponent} from './app.component';
import {HomeComponent} from './home/home.component';
import {AppRoutingModule} from "./app-routing.module";
import {MenuComponent} from './menu/menu.component';
import {CommonModule} from "@angular/common";
import {ImgPerspectiveComponent} from './components/img-perspective/img-perspective.component';
import {AboutComponent} from './about/about.component';
import {MousewheelDirective} from './directives/mousewheel.directive';
import {ProjectsComponent} from './projects/projects.component';

@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        MenuComponent,
        ImgPerspectiveComponent,
        AboutComponent,
        MousewheelDirective,
        ProjectsComponent
    ],
    imports: [
        BrowserModule,
        // AppRoutingModule,
        FormsModule,
        CommonModule,
        HttpModule
    ],
    providers: [],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// /Users/davidlagace/Sites/david-lagace-website/src/app/app.module.ts